import em from "./em.png"
import pc from "./pc.png"
import dis from "./whatsapp.png"
import ig from "./ig.png"
import email from "./email.png"
import { Link } from "react-router-dom"
import tw from "./twitter.png"

function Footer() {
        return (
                <div className="Footer">
                        <div className="main-footer-box ">
                                {/* <div className="footer-box">
                                        <div className="company-footer">
                                                <p className="logoText" >Caninely</p>
                                                <p className="footer-about" >Caninely is a one-stop destination for all canine things.</p>
                                                <p className="footer-reach">Reach out to us</p>
                                                <p className="footer-about" >Get your questions answered about Caninely</p>
                                                <div className="footer-icons">
                                                       
                                                        <p className="footer-email" ><a href="mailto:strayfarm9@gmail.com" >sahilkalkal108@gmail.com</a></p>
                                                </div>
                                               
                                        </div>
                                        <div className="second-footer">
                                                <div className="">
                                                        <p className="footer-head-sub">Comapany</p>
                                                        <div className="footer-menu">
                                                                <Link to="/home">
                                                                        <p className="footer-menuItem">Home</p>
                                                                </Link>
                                                                <Link to="/shop">
                                                                        <p className="footer-menuItem">Shop</p>
                                                                </Link>
                                                                <Link to="/categories">
                                                                        <p className="footer-menuItem">Categories</p>
                                                                </Link>

                                                               


                                                        </div>
                                                </div>
                                                
                                        </div>
                                </div> */}
                                <div className="lower-footer">
                                        <p className="footer-lower-txt" >&copy;2024 Caninely  </p>
                                        <div className="lower-footer-icons">
                                               
                                                <a href="mailto:strayfarm9@gmail.com" target="blank">
                                                        <img className="lower-footer-icon" src={email} />
                                                </a>
                                                <a href="https://instagram.com/strayfarm" target="blank">
                                                        <img className="lower-footer-icon" src={ig} />
                                                </a>


                                              
                                        </div>
                                </div>
                        </div>
                </div>
        )
}

export default Footer;